import React from 'react';
import TabNavigation from '../../../components/tabNavigation/TabNavigation';
import {TodayTasksContainer} from '../styles/Dashboard.style';
import {PerformanceTable} from './PerformanceTable';
export const PerformanceTab = () => {
  const tabs = [
    {
      name: 'Top Performers',
      element: PerformanceTable,
      props: {
        sort: -1,
      },
    },
    {
      name: 'Bottom Performers',
      element: PerformanceTable,
      props: {
        sort: 1,
      },
    },
  ];
  return (
    <TodayTasksContainer>
      <TabNavigation tabs={tabs} />
    </TodayTasksContainer>
  );
};
